module.exports = __webpack_public_path__ + "img/icon-mi.8b60fa7e.png";